<template>
  <div class="home">
    <van-nav-bar
      :title="$t('PackageDetail.title')"
      left-arrow
      fixed
      :z-index="9"
      @click-left="$router.push('/E_Dishes')"
    >
    </van-nav-bar>
    <div v-if="detail" style="margin-top:47px">
      <van-image
        v-if="detail.image"
        width="100%"
        fit="contain"
        :src="detail.image.path"
      />
      <div style="height: 3px;width: 100%;background-color: #F3F5F7;"></div>
      <div class="info">
        <div
          class="noExceed"
          style="height: 30px;font-size: 16px;line-height: 30px;"
        >
          {{ detail.name }}
        </div>
        <div class="noExceed" style="font-size: 16px;line-height: 16px;">
          {{ detail.name_en }}
        </div>
        <p
          style="font-size: 14px;color: #666;padding: 0;margin-bottom: 10px;margin-top: 10px;word-break: break-all;"
        >
          {{ detail.introduction }}
        </p>
        <van-rate
          style="height: 16px;"
          v-model="detail.level"
          readonly
          :size="16"
          gutter="3px"
          icon="./static/img/Recommend-s.png"
          void-icon="./static/img/Recommend.png"
        />

        <div class="fontLine">
          <span
            class="currentPrice"
            v-if="detail.original_price != 0 || detail.special_price != 0"
            >{{ sessionStorage.getItem("currency") }}
            {{
              detail.type == "o" ? detail.original_price : detail.special_price
            }}</span
          >&nbsp;&nbsp;&nbsp;<span class="oldPrice" v-show="detail.type == 's'"
            >{{ sessionStorage.getItem("currency") }}
            {{ detail.original_price }}</span
          >
        </div>
      </div>
      <div style="height: 3px;width: 100%;background-color: #F3F5F7;"></div>
      <div
        v-if="detail.perfer && detail.perfer.data.length > 0"
        class="tasteGropu"
      >
        <div
          class="tasteItem"
          v-for="(item, index) in detail.perfer.data"
          :key="index"
        >
          <div class="tasteItemTitle">{{ item.name }}</div>
          <div
            v-for="(val, key) in item.category.data"
            :key="key"
            class="tasteItemRadio"
            :class="[perferResult[index] == val.id ? 'tasteItemRadio_act' : '']"
            @click="changeResult(index, val.id)"
          >
            {{ val.name }}
            <span v-if="val.price != 0">{{ currency }} {{ val.price }}</span>
          </div>
        </div>
        <div class="tasteItem">
          <div class="tasteItemTitle">{{ $t("PackageDetail.remark") }}</div>
          <van-field
            v-model="remark[0]"
            rows="3"
            autosize
            type="textarea"
            maxlength="80"
            :placeholder="$t('PackageDetail.inputRemark')"
            show-word-limit
            style="text-indent: 10px;border:1px solid #2f75f4;border-radius: 5px;"
          />
        </div>
      </div>
    </div>
    <div style="height: 50px;background: #F3F5F7;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      isTasteShow: false,
      perferResult: [],
      remark: [""],
      //购物车数据
      isShopCartShow: false,
      shopCart: {},
      //动效 声音
      visible: false,
      bottomNum: 33,
      leftNum: 50,
      musicPlayer: new Audio()
    };
  },
  mounted: function() {
    this.getDishDetail();
    this.musicPlayer.src = "./static/music/add_dish.mp3";
    this.musicPlayer.loop = false;
    this.musicPlayer.preload = "auto";
  },
  methods: {
    getDishDetail() {
      this.$axios({
        method: "get",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build + "/api/menu/" + this.$route.params.id + "/customerIndex"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.detail = res.data.data;
            for (var i = 0; i < this.detail.perfer.data.length; i++) {
              if (this.detail.perfer.data[i].category.data.length > 0) {
                this.perferResult.push(
                  this.detail.perfer.data[i].category.data[0].id
                );
              }
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    showTaste() {
      this.isTasteShow = true;
    },
    changeResult(index, id) {
      this.$set(this.perferResult, index, id);
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-field__body > input {
  text-align: right;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f4;
}
/deep/ .van-divider {
  border-width: 2px;
}
.home {
  width: 100%;
  height: auto;
  background-color: #fff;
}
.currentPrice {
  font-size: 18px;
  color: #ff6666;
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.info {
  width: 90%;
  margin-left: 5%;
  height: auto;
  position: relative;
}
.fontLine {
  padding-bottom: 10px;
  font-size: 14px;
}
.setPerfer {
  position: absolute;
  width: 50px;
  height: 50px;
  bottom: 10px;
  right: 0px;
}
.setPerfer span {
  position: absolute;
  font-size: 12px;
  top: 16px;
  left: 7px;
}
.flexNone {
  flex: none;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  font-size: 18px;
  float: left;
}
.cart_right {
  width: 40%;
  height: 34px;
  line-height: 34px;
  float: right;
  text-align: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
}
.total_price {
  height: 34px;
  line-height: 34px;
  font-size: 20px;
  text-indent: 10px;
}
.tasteGropu {
  width: 90%;
  margin-left: 5%;
  font-size: 16px;
  height: auto;
}
.tasteItem {
  width: 100%;
  height: auto;
  color: #222;
}
.tasteItemTitle {
  width: 100%;
  height: 45px;
  line-height: 45px;
}
.tasteItemRadio {
  width: 100%;
  height: 33px;
  line-height: 33px;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid #2f75f4;
  text-indent: 10px;
  margin-bottom: 20px;
}
.tasteItemRadio span {
  margin-left: 0.625rem;
  color: #ff6666;
}
.tasteItemRadio_act {
  background-color: #2f75f4;
  color: #fff;
}
.van-button__text {
  color: #222;
}
/*购物车样式*/
.cartDetail {
  width: 100%;
  height: auto;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(to right, #ffc914, #ffc813);
  border-radius: 50%;
}
.cart_dish {
  width: 100%;
}
.cart_dish_name {
  width: 80%;
  height: 50px;
  line-height: 50px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.son_dish {
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  padding-top: 10px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  clear: both;
}
.realPrice {
  color: #000;
}
.inDot {
  width: 24px;
  height: 24px;
  background: #ee0a24;
  border-radius: 50%;
  position: fixed;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/e_menu/DishDetail.vue